import api from './api';

export const blogService = {
  list: async (params = {}) => {
    const res = await api.get('/blogs', { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/blogs/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post('/blogs', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/blogs/${id}`, data);
    return res.data;
  },

  uploadCoverImage: async (file) => {
    const formData = new FormData();
    formData.append('images', file);
    const res = await api.post('/blogs/upload-cover', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/blogs/${id}`);
    return res.data;
  }
};

export default blogService;


